import * as React from "react";

import { mergeStyles } from "@fluentui/react/lib/Styling";

import { AppGalleryButton } from "@1js/acui-gallery";

import { displayNameStylesWithPreviewStyleLabel } from "../AppFontStylesFullGallery/AppFontStylesFullGallery.styles";
import type { AppFontStylesTwoRowGalleryButtonProps } from "../AppFontStylesTwoRowGalleryButton";

export const AppFontStylesTwoRowPreviewGalleryButton: React.FunctionComponent<AppFontStylesTwoRowGalleryButtonProps> =
  React.memo((galleryButton: AppFontStylesTwoRowGalleryButtonProps) => {
    const previewStyle = galleryButton.style && galleryButton.style.label;
    const textContainerStyle =
      galleryButton && galleryButton.style && galleryButton.style.textContainer;
    const displayNameStyle = galleryButton.previewStyleLabel
      ? displayNameStylesWithPreviewStyleLabel
      : galleryButton.style && galleryButton.style.label;
    return (
      <AppGalleryButton
        {...galleryButton}
        title={undefined}
        automationType="AppFontStylesTwoRowPreview"
        label={galleryButton.styleDisplayName}
        ariaLabel={
          galleryButton.previewStyleFontNameAndSize != null
            ? galleryButton.customTooltip
            : galleryButton.styleDisplayName
        }
        shouldTakeFocus={true}
        showTooltip={true}
      >
        <div className={mergeStyles(textContainerStyle)}>
          <div className={mergeStyles(previewStyle)}>
            {galleryButton.previewStyleFontNameAndSize != null
              ? galleryButton.styleDisplayName
              : galleryButton.previewStyleLabel}
          </div>
          <div className={mergeStyles(displayNameStyle)}>
            {galleryButton.previewStyleFontNameAndSize != null
              ? galleryButton.previewStyleFontNameAndSize
              : galleryButton.styleDisplayName}
          </div>
        </div>
      </AppGalleryButton>
    );
  });
